export default {"src":"/_next/static/media/icon-success-toast.cc95a44a.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};